import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2 } from "lucide-react";
import { DEFAULT_CONTENT } from "@/context/SiteContext";

/** Grouped fields for the content editor UI. */
const GROUPS = [
  {
    id: "home",
    label: "Pagina Home",
    fields: [
      { key: "home.hero.eyebrow", label: "Eyebrow (text mic deasupra titlului)", type: "text" },
      { key: "home.hero.title_1", label: "Titlu — Rând 1", type: "text" },
      { key: "home.hero.title_2", label: "Titlu — Rând 2 (italic)", type: "text" },
      { key: "home.hero.title_3", label: "Titlu — Rând 3 (după italic)", type: "text" },
      { key: "home.hero.description", label: "Descriere hero", type: "textarea" },
      { key: "home.hero.cta_primary", label: "Buton primar (text)", type: "text" },
      { key: "home.hero.cta_secondary", label: "Buton secundar (text)", type: "text" },
      { key: "home.hero.image_url", label: "URL imagine hero", type: "image" },
      { key: "home.eu.title_1", label: "EU block — Rând 1 titlu", type: "text" },
      { key: "home.eu.title_2", label: "EU block — Rând 2 titlu (italic)", type: "text" },
      { key: "home.eu.description", label: "EU block — Descriere", type: "textarea" },
      { key: "home.eu.stat1_num", label: "Statistică 1 — Număr", type: "text" },
      { key: "home.eu.stat1_label", label: "Statistică 1 — Etichetă", type: "text" },
      { key: "home.eu.stat2_num", label: "Statistică 2 — Număr", type: "text" },
      { key: "home.eu.stat2_label", label: "Statistică 2 — Etichetă", type: "text" },
      { key: "home.cta.title_1", label: "CTA final — Rând 1", type: "text" },
      { key: "home.cta.title_2", label: "CTA final — Rând 2 (italic)", type: "text" },
      { key: "home.cta.title_3", label: "CTA final — Rând 3", type: "text" },
    ],
  },
  {
    id: "about",
    label: "Pagina Despre",
    fields: [
      { key: "about.hero.title_1", label: "Titlu hero — Rând 1", type: "text" },
      { key: "about.hero.title_2", label: "Titlu hero — Rând 2 (italic)", type: "text" },
      { key: "about.hero.title_3", label: "Titlu hero — Rând 3", type: "text" },
      { key: "about.who.heading", label: "Sub-titlu „Cine suntem\"", type: "text" },
      { key: "about.who.p1", label: "Paragraf 1", type: "textarea" },
      { key: "about.who.p2", label: "Paragraf 2", type: "textarea" },
    ],
  },
  {
    id: "contact",
    label: "Pagina Contact",
    fields: [
      { key: "contact.hero.title_1", label: "Titlu — Rând 1", type: "text" },
      { key: "contact.hero.title_2", label: "Titlu — Rând 2 (italic)", type: "text" },
      { key: "contact.sales.email", label: "Vânzări — Email", type: "text" },
      { key: "contact.sales.phone1", label: "Vânzări — Telefon 1", type: "text" },
      { key: "contact.sales.phone2", label: "Vânzări — Telefon 2", type: "text" },
      { key: "contact.service.email", label: "Service — Email", type: "text" },
      { key: "contact.service.phone1", label: "Service — Telefon", type: "text" },
      { key: "contact.accounting.email", label: "Contabilitate — Email", type: "text" },
      { key: "contact.accounting.phone1", label: "Contabilitate — Telefon", type: "text" },
      { key: "contact.address1_title", label: "Adresă 1 — Titlu", type: "text" },
      { key: "contact.address1", label: "Adresă 1 — Text", type: "text" },
      { key: "contact.address2_title", label: "Adresă 2 — Titlu", type: "text" },
      { key: "contact.address2", label: "Adresă 2 — Text", type: "text" },
      { key: "contact.address3_title", label: "Adresă 3 — Titlu", type: "text" },
      { key: "contact.address3", label: "Adresă 3 — Text", type: "text" },
      { key: "contact.hours", label: "Program", type: "text" },
    ],
  },
  {
    id: "footer",
    label: "Footer",
    fields: [
      { key: "footer.tagline", label: "Tagline (paragraf)", type: "textarea" },
      { key: "footer.address", label: "Adresă (linia scurtă)", type: "text" },
      { key: "footer.copyright_right", label: "Copyright — text dreapta", type: "text" },
    ],
  },
  {
    id: "buttons",
    label: "Butoane (label + link)",
    fields: [
      // Navbar
      { key: "btn.nav.cta.label", label: "Navbar · buton CTA — etichetă", type: "text" },
      { key: "btn.nav.cta.link", label: "Navbar · buton CTA — link (URL)", type: "link" },
      // Home hero
      { key: "btn.home.hero.primary.label", label: "Home Hero · buton primar — etichetă", type: "text" },
      { key: "btn.home.hero.primary.link", label: "Home Hero · buton primar — link (URL)", type: "link" },
      { key: "btn.home.hero.secondary.label", label: "Home Hero · buton secundar — etichetă", type: "text" },
      { key: "btn.home.hero.secondary.link", label: "Home Hero · buton secundar — link (URL)", type: "link" },
      // Home EU section
      { key: "btn.home.eu.label", label: "Home Proiecte UE · buton — etichetă", type: "text" },
      { key: "btn.home.eu.link", label: "Home Proiecte UE · buton — link (URL)", type: "link" },
      // Home departments header link
      { key: "btn.home.departments_all.label", label: "Home Departamente · link Toate departamentele — etichetă", type: "text" },
      { key: "btn.home.departments_all.link", label: "Home Departamente · link Toate departamentele — link (URL)", type: "link" },
      // Home CTA
      { key: "btn.home.cta.label", label: "Home CTA final · buton — etichetă", type: "text" },
      { key: "btn.home.cta.link", label: "Home CTA final · buton — link (URL)", type: "link" },
      // About
      { key: "btn.about.cta.label", label: "Despre · buton CTA — etichetă", type: "text" },
      { key: "btn.about.cta.link", label: "Despre · buton CTA — link (URL)", type: "link" },
      // Departments detail
      { key: "btn.dept.cta.label", label: "Pagini departament · buton CTA — etichetă", type: "text" },
      { key: "btn.dept.cta.link", label: "Pagini departament · buton CTA — link (URL)", type: "link" },
      // Blog article
      { key: "btn.blog.article.cta.label", label: "Articol blog · buton CTA — etichetă", type: "text" },
      { key: "btn.blog.article.cta.link", label: "Articol blog · buton CTA — link (URL)", type: "link" },
      // Contact form
      { key: "btn.contact.submit.label", label: "Formular contact · buton Trimite — etichetă", type: "text" },
    ],
  },
  {
    id: "section_titles",
    label: "Titluri secțiuni",
    fields: [
      // Home
      { key: "section.home.eu.eyebrow", label: "Home · Proiecte UE — eyebrow", type: "text" },
      { key: "section.home.departments.eyebrow", label: "Home · Departamente — eyebrow (label)", type: "text" },
      { key: "section.home.departments.title_1", label: "Home · Departamente — titlu linia 1", type: "text" },
      { key: "section.home.departments.title_2", label: "Home · Departamente — titlu linia 2", type: "text" },
      { key: "section.home.cta.eyebrow", label: "Home · CTA final — eyebrow", type: "text" },
      // Departments list page
      { key: "section.departments.hero.eyebrow", label: "Listă departamente · Hero — eyebrow", type: "text" },
      { key: "section.departments.hero.title_1", label: "Listă departamente · Hero — titlu linia 1", type: "text" },
      { key: "section.departments.hero.title_2", label: "Listă departamente · Hero — titlu linia 2", type: "text" },
      // About
      { key: "section.about.hero.eyebrow", label: "Despre · Hero — eyebrow", type: "text" },
      { key: "section.about.who.eyebrow", label: "Despre · Cine suntem — eyebrow", type: "text" },
      { key: "section.about.legal.eyebrow", label: "Despre · Structură legală — eyebrow", type: "text" },
      { key: "section.about.legal.title", label: "Despre · Structură legală — titlu", type: "text" },
      { key: "section.about.cta.eyebrow", label: "Despre · CTA final — eyebrow", type: "text" },
      { key: "section.about.cta.title", label: "Despre · CTA final — titlu", type: "text" },
      // Contact
      { key: "section.contact.hero.eyebrow", label: "Contact · Hero — eyebrow", type: "text" },
      { key: "section.contact.depts.eyebrow", label: "Contact · Departamente — eyebrow", type: "text" },
      { key: "section.contact.offices.eyebrow", label: "Contact · Sedii — eyebrow", type: "text" },
      // Blog list
      { key: "section.blog.hero.eyebrow", label: "Blog · Hero — eyebrow", type: "text" },
      { key: "section.blog.hero.title_1", label: "Blog · Hero — titlu linia 1", type: "text" },
      { key: "section.blog.hero.title_2", label: "Blog · Hero — titlu linia 2 (italic)", type: "text" },
      { key: "section.blog.hero.title_3", label: "Blog · Hero — titlu linia 3", type: "text" },
      // Department detail (applies to all department pages)
      { key: "section.dept.manifest.eyebrow", label: "Departament · Manifest — eyebrow", type: "text" },
      { key: "section.dept.manifest.title_1", label: "Departament · Manifest — titlu linia 1 (ex. Ce facem)", type: "text" },
      { key: "section.dept.manifest.title_2", label: "Departament · Manifest — titlu linia 2 (italic, ex. exact.)", type: "text" },
      { key: "section.dept.services.eyebrow", label: "Departament · Servicii — eyebrow", type: "text" },
      { key: "section.dept.highlights.eyebrow", label: "Departament · Capacități — eyebrow", type: "text" },
      { key: "section.dept.gallery.eyebrow", label: "Departament · Galerie — eyebrow", type: "text" },
      { key: "section.dept.gallery.title_1", label: "Departament · Galerie — titlu linia 1", type: "text" },
      { key: "section.dept.gallery.title_2", label: "Departament · Galerie — titlu linia 2 (italic)", type: "text" },
      { key: "section.dept.programs.eyebrow", label: "Departament · Programe UE — eyebrow", type: "text" },
      { key: "section.dept.programs.title_1", label: "Departament · Programe UE — titlu linia 1", type: "text" },
      { key: "section.dept.programs.title_2", label: "Departament · Programe UE — titlu linia 2 (italic)", type: "text" },
      { key: "section.dept.references.eyebrow", label: "Departament · Referințe — eyebrow", type: "text" },
      { key: "section.dept.references.title", label: "Departament · Referințe — titlu", type: "text" },
      { key: "section.dept.domains.eyebrow", label: "Departament · Domenii — eyebrow", type: "text" },
      { key: "section.dept.values.eyebrow", label: "Departament · Valori — eyebrow", type: "text" },
      { key: "section.dept.cta.eyebrow", label: "Departament · CTA final — eyebrow", type: "text" },
    ],
  },
  {
    id: "urls",
    label: "URL-uri Pagini",
    fields: [
      { key: "page.about.slug", label: "Slug pagina Despre", type: "slug", prefix: "/" },
      { key: "page.departments.slug", label: "Slug listă departamente", type: "slug", prefix: "/" },
      { key: "page.blog.slug", label: "Slug pagina Blog", type: "slug", prefix: "/" },
      { key: "page.contact.slug", label: "Slug pagina Contact", type: "slug", prefix: "/" },
    ],
  },
  {
    id: "analytics",
    label: "Analytics & Cookies",
    fields: [
      { key: "analytics.ga_measurement_id", label: "Google Analytics 4 · Measurement ID (G-XXXXXXXXXX)", type: "text" },
      { key: "analytics.enabled", label: "Activează Google Analytics (yes/no)", type: "text" },
      { key: "cookie.banner.title", label: "Cookie banner — Titlu", type: "text" },
      { key: "cookie.banner.text", label: "Cookie banner — Text explicativ", type: "textarea" },
      { key: "cookie.banner.accept", label: "Cookie banner — Buton Accept", type: "text" },
      { key: "cookie.banner.decline", label: "Cookie banner — Buton Refuz", type: "text" },
    ],
  },
  {
    id: "repeatables",
    label: "Repetabile",
    fields: [
      {
        key: "contact.groups",
        label: "Contact · Grupuri (Vânzări, Service, Contabilitate etc.)",
        type: "object-array",
        itemLabel: "Grup",
        fields: [
          { key: "label", label: "Etichetă (ex. Vânzări)", type: "text" },
          { key: "email", label: "Email", type: "text" },
          { key: "phones", label: "Telefoane (separă cu virgulă)", type: "text" },
        ],
      },
      {
        key: "contact.offices",
        label: "Contact · Sedii / Adrese",
        type: "object-array",
        itemLabel: "Sediu",
        fields: [
          { key: "title", label: "Denumire (ex. Sediu Oradea)", type: "text" },
          { key: "address", label: "Adresă completă", type: "textarea" },
        ],
      },
      {
        key: "about.entities",
        label: "Despre · Entități legale (Suntec Trade, Suntec SRL etc.)",
        type: "object-array",
        itemLabel: "Companie",
        fields: [
          { key: "name", label: "Denumire", type: "text" },
          { key: "cui", label: "CUI", type: "text" },
          { key: "reg", label: "Nr. registru", type: "text" },
          { key: "capital", label: "Capital social", type: "text" },
          { key: "iban", label: "IBAN", type: "text" },
          { key: "address", label: "Adresă", type: "textarea" },
        ],
      },
      {
        key: "home.stats",
        label: "Home · Statistici (300+ proiecte etc.)",
        type: "object-array",
        itemLabel: "Statistică",
        fields: [
          { key: "k", label: "Cifră (ex. 300+)", type: "text" },
          { key: "v", label: "Descriere", type: "text" },
        ],
      },
    ],
  },
];

/** Parse a JSON string safely into an array. */
function parseJsonArray(str) {
  if (!str) return [];
  if (Array.isArray(str)) return str;
  try {
    const v = JSON.parse(str);
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}

/** Editor for an array of homogeneous objects (repeatable rows). */
function ObjectArrayField({ field, value, onChange }) {
  const list = parseJsonArray(value);
  const smallInput = "w-full bg-white border border-black rounded-none px-3 py-2 text-sm focus:outline-none";

  const commit = (arr) => onChange(JSON.stringify(arr));
  const setAt = (i, key, v) =>
    commit(list.map((x, idx) => (idx === i ? { ...x, [key]: v } : x)));
  const add = () =>
    commit([...list, Object.fromEntries(field.fields.map((f) => [f.key, ""]))]);
  const del = (i) => commit(list.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-3" data-testid={`objarr-${field.key}`}>
      <div className="flex items-center justify-between">
        <span className="font-mono-label text-black/60 text-[11px]">
          {list.length} {list.length === 1 ? "rând" : "rânduri"}
        </span>
        <button
          type="button"
          onClick={add}
          data-testid={`objarr-add-${field.key}`}
          className="font-mono-label border border-black px-3 py-1 hover:bg-black hover:text-white inline-flex items-center gap-1 text-[11px]"
        >
          <Plus size={12} /> Adaugă {field.itemLabel || "rând"}
        </button>
      </div>
      {list.map((row, i) => (
        <div key={i} className="border border-black p-4 space-y-2" data-testid={`objarr-row-${field.key}-${i}`}>
          <div className="flex items-center justify-between">
            <span className="font-mono-label text-black/50 text-[10px]">
              {field.itemLabel || "Rând"} #{String(i + 1).padStart(2, "0")}
            </span>
            <button
              type="button"
              onClick={() => del(i)}
              data-testid={`objarr-del-${field.key}-${i}`}
              title="Șterge acest rând"
              className="border border-black w-8 h-8 flex items-center justify-center hover:bg-red-600 hover:text-white hover:border-red-600"
            >
              <Trash2 size={12} />
            </button>
          </div>
          {field.fields.map((sf) => (
            <div key={sf.key}>
              <label className="font-mono-label text-black/50 text-[10px] block mb-1">
                {sf.label}
              </label>
              {sf.type === "textarea" ? (
                <textarea
                  rows={2}
                  className={smallInput}
                  value={row[sf.key] || ""}
                  onChange={(e) => setAt(i, sf.key, e.target.value)}
                />
              ) : (
                <input
                  className={smallInput}
                  value={row[sf.key] || ""}
                  onChange={(e) => setAt(i, sf.key, e.target.value)}
                />
              )}
            </div>
          ))}
        </div>
      ))}
      {list.length === 0 && (
        <div className="border border-dashed border-black/30 p-6 text-center font-mono-label text-black/40 text-[11px]">
          Niciun rând. Apasă „Adaugă {field.itemLabel || "rând"}" pentru a începe.
        </div>
      )}
    </div>
  );
}


function sanitizeSlug(v) {
  return (v || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/^\/+|\/+$/g, "")
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-{2,}/g, "-");
}

export default function ContentEditor({ onSaved }) {
  const [values, setValues] = useState({});
  const [dirty, setDirty] = useState({});
  const [saving, setSaving] = useState(false);
  const [activeGroup, setActiveGroup] = useState(GROUPS[0].id);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/site/content");
        // Merge with DEFAULT_CONTENT so admin sees the current on-screen text
        setValues({ ...DEFAULT_CONTENT, ...data });
      } catch {
        setValues({ ...DEFAULT_CONTENT });
      }
    })();
  }, []);

  const setVal = (key, v) => {
    setValues((prev) => ({ ...prev, [key]: v }));
    setDirty((prev) => ({ ...prev, [key]: v }));
  };

  const saveAll = async () => {
    if (Object.keys(dirty).length === 0) return toast.info("Nimic de salvat");
    setSaving(true);
    try {
      await api.post("/admin/site/content/bulk", dirty);
      toast.success(`${Object.keys(dirty).length} câmpuri salvate`);
      setDirty({});
      onSaved?.();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setSaving(false);
    }
  };

  const resetField = (key) => {
    setVal(key, DEFAULT_CONTENT[key] || "");
  };

  const activeFields = GROUPS.find((g) => g.id === activeGroup)?.fields || [];
  const dirtyCount = Object.keys(dirty).length;

  const input = "w-full bg-white border border-black rounded-none px-4 py-3 focus:outline-none";

  return (
    <div data-testid="content-editor">
      {/* Sticky save bar */}
      <div className="sticky top-20 z-20 bg-white border border-black p-4 mb-8 flex items-center justify-between">
        <div>
          <div className="font-mono-label text-black/60">Editor conținut</div>
          <div className="mt-1 text-sm">
            {dirtyCount > 0
              ? <span className="text-black"><strong>{dirtyCount}</strong> {dirtyCount === 1 ? "modificare nesalvată" : "modificări nesalvate"}</span>
              : <span className="text-black/50">Toate modificările sunt salvate</span>}
          </div>
        </div>
        <button onClick={saveAll} disabled={saving || dirtyCount === 0} data-testid="save-content-btn"
          className="font-mono-label bg-black text-white px-6 py-3 border border-black hover:bg-white hover:text-black disabled:opacity-40 disabled:cursor-not-allowed inline-flex items-center gap-2">
          <Save size={14} /> {saving ? "Se salvează..." : "Salvează tot"}
        </button>
      </div>

      {/* Group tabs */}
      <div className="border-b border-black mb-8 flex flex-wrap">
        {GROUPS.map((g) => (
          <button key={g.id} data-testid={`content-tab-${g.id}`}
            onClick={() => setActiveGroup(g.id)}
            className={`font-mono-label px-5 py-3 border-r border-black ${activeGroup === g.id ? "bg-black text-white" : "hover:bg-black/5"}`}>
            {g.label}
          </button>
        ))}
      </div>

      {/* Fields */}
      <div className="space-y-6 max-w-4xl">
        {activeFields.map((f) => (
          <div key={f.key} className="border border-black p-5" data-testid={`field-${f.key}`}>
            <div className="flex items-center justify-between gap-4 mb-3">
              <label className="font-mono-label text-black/70">
                {f.label}
                {dirty[f.key] !== undefined && <span className="ml-2 text-black bg-yellow-200 px-1">MODIFICAT</span>}
              </label>
              <button onClick={() => resetField(f.key)} className="font-mono-label text-black/50 hover:text-black text-[10px]">
                Resetează
              </button>
            </div>

            {f.type === "textarea" ? (
              <textarea rows={4} className={input}
                data-testid={`input-${f.key}`}
                value={values[f.key] || ""}
                onChange={(e) => setVal(f.key, e.target.value)} />
            ) : f.type === "image" ? (
              <div className="space-y-3">
                <input className={input} data-testid={`input-${f.key}`}
                  value={values[f.key] || ""}
                  onChange={(e) => setVal(f.key, e.target.value)}
                  placeholder="https://... sau /api/media/{id}" />
                {values[f.key] && (
                  <div className="border border-black inline-block">
                    <img src={values[f.key]} alt="preview" className="max-h-48 max-w-full block grayscale-img" />
                  </div>
                )}
              </div>
            ) : f.type === "slug" ? (
              <div className="space-y-2">
                <div className="flex items-stretch border border-black">
                  <span className="bg-black text-white px-3 flex items-center font-mono-label">
                    {f.prefix || "/"}
                  </span>
                  <input
                    className="flex-1 bg-white px-4 py-3 focus:outline-none"
                    data-testid={`input-${f.key}`}
                    value={values[f.key] || ""}
                    onChange={(e) => setVal(f.key, sanitizeSlug(e.target.value))}
                    placeholder="ex: despre-noi"
                  />
                </div>
                <div className="font-mono-label text-black/50 text-[10px]">
                  URL final: {window.location.origin}{f.prefix || "/"}{values[f.key] || ""}
                </div>
              </div>
            ) : f.type === "link" ? (
              <div className="space-y-2">
                <input
                  className={input}
                  data-testid={`input-${f.key}`}
                  value={values[f.key] || ""}
                  onChange={(e) => setVal(f.key, e.target.value)}
                  placeholder="/contact sau https://example.com"
                />
                <div className="font-mono-label text-black/50 text-[10px]">
                  {(() => {
                    const v = values[f.key] || "";
                    if (!v) return "Neconfigurat — folosește destinația default a butonului";
                    if (/^https?:\/\//i.test(v)) return `Link extern → deschide în tab nou: ${v}`;
                    return `Link intern → ${window.location.origin}${v.startsWith("/") ? v : "/" + v}`;
                  })()}
                </div>
              </div>
            ) : f.type === "object-array" ? (
              <ObjectArrayField
                field={f}
                value={values[f.key]}
                onChange={(v) => setVal(f.key, v)}
              />
            ) : (
              <input className={input} data-testid={`input-${f.key}`}
                value={values[f.key] || ""}
                onChange={(e) => setVal(f.key, e.target.value)} />
            )}

            <div className="mt-2 font-mono-label text-black/40 text-[10px]">key: {f.key}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
